
export default {
  // nav_data参数意思
  //   link---链接后缀部分不要带语言
  //   text---文本信息
  //   type---类型a表示加链接-span表示纯文本
  //   translation --- 是否需要翻译true不需要翻译false需要---默认为false
  props: {
    navData: {
      type: Array,
      default: () => []
    },
    navtype: {
      // 面包屑导航类型
      type: Boolean,
      default: true
    },
    iskey: {
      type: Boolean,
      default: false
    },
  }
}
